<template>
  <footer :class="$style.footer">
    <div :class="$style.content">
      <div :class="$style.top">
        <div :class="$style.left">
          <div :class="$style.logos">
            <a
              href="https://feis.bstu.by/feis@bstu.by"
              target="__blank"
              :class="$style.textLogo"
            >
              <img src="/images/logo2.png" alt="" />
            </a>
          </div>
          <div :class="$style.address">
            <div>© Факультет электронно-информационных систем</div>
            <div>Расположение – корпус №2, ауд. 2/400, 2/400а, 2/401</div>
          </div>
        </div>
        <div :class="$style.right">
          <div :class="$style.column">
            <div :class="$style.title">Важное</div>
            <div :class="$style.list">
              <div @click="scrollToSection('about')">О празднике</div>
              <div @click="scrollToSection('cards')">Мероприятия</div>
              <a href="/images/afisha.pdf" target="__blank">Посмотреть афишу</a>
            </div>
          </div>
          <div :class="$style.column">
            <div :class="$style.title">Для связи</div>
            <div :class="$style.list">
              <a href="mailto:feis@bstu.by" target="__blank"> feis@bstu.by </a>
              <a href="tel:80162321796">8 (0162) 32-17-96</a>
              <a href="tel:80162321713">8 (0162) 32-17-13</a>
            </div>
          </div>
        </div>
      </div>
      <div :class="$style.bottom">
        <a href="https://www.tbank.ru/" target="__blank">
          <img src="/icons/partners/tbank.png" alt="" />
        </a>
        <a href="https://scr.by/" target="__blank">
          <img src="/icons/partners/scr.svg" alt="" />
        </a>
        <a href="https://ru.savushkin.com/" target="__blank">
          <img src="/icons/partners/savushkin.svg" alt="" />
        </a>
        <a href="https://1soft.by/" target="__blank">
          <img src="/icons/partners/youkola.svg" alt="" />
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  methods: {
    scrollToSection(id) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>

<style lang="scss" module>
.footer {
  padding: 3rem 1rem;
  background-color: $white;
  margin: 0 0 2rem 0;
  @include custom(930) {
    display: flex;
    justify-content: center;
  }
}
.content {
  max-width: 78.75rem;
  margin: 0 auto;

  .top {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    margin: 0 0 4rem 0;
    @include custom(930) {
      grid-template-columns: 1fr;
    }
    .left {
      .logos {
        display: flex;
        align-items: center;
        gap: 3rem;
        margin: 0 0 2rem 0;
        @include custom(930) {
          justify-content: center;
        }
        .logo {
          cursor: pointer;
          max-width: 12rem;
          max-height: 2.875rem;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .textLogo {
          cursor: pointer;
          max-width: 12rem;
          max-height: 3.5rem;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .address {
        color: $grey-40;
        font-weight: 500;
        line-height: 130%;
        @include custom(930) {
          text-align: center;
        }
        @include custom(620) {
          font-size: 0.8rem;
        }
      }
    }
    .right {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;

      .column {
        .title {
          margin: 0 0 1.5rem 0;
        }
        .list {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          > div,
          a {
            cursor: pointer;
            color: $grey-40;
            font-weight: 500;
            line-height: 130%;
            transition: all 0.3s ease-in-out;
            &:hover {
              color: $red;
              font-weight: 700;
            }
          }
        }
        &:last-child {
          @include custom(930) {
            text-align: right;
          }
        }
      }
    }
  }
  .bottom {
    display: flex;
    align-items: center;
    gap: 2rem;
    a {
      cursor: pointer;
    }
    @include custom(910) {
      display: grid;
      grid-template-columns: 1fr;
      align-items: center;
      gap: 1rem;
      img {
        max-width: 100%;
      }
    }
  }
}
</style>
